import {Component, OnInit, OnDestroy} from '@angular/core';
import {GonvarriProduct} from "../../core/models/gonvarri-product.model";
import {BaseSiteService} from "@spartacus/core";

import {ICON_TYPE, LaunchDialogService} from "@spartacus/storefront";
import {GonvarriCartUiEventAddToCart} from "../../core/events/GonvarriCartUiEventAddToCart";
import {isAsturias} from "../../utils/check-environment";
import {calcKgEach, DEFAULT_KG, MAX_KG, MIN_KG} from "../../utils/weight-utils";

@Component({
  selector: 'app-gonvarri-quick-stock-title-modal',
  templateUrl: './gonvarri-quick-stock-title-modal.component.html',
  styleUrl: './gonvarri-quick-stock-title-modal.component.scss',
  standalone: false
})
export class GonvarriQuickStockTitleModalComponent implements OnInit, OnDestroy {

  product: GonvarriProduct | undefined = {} as GonvarriProduct;

  numberOfSheets: number = 1;
  packageWeigth: number = 1000;
  curLenght: number = 1000;
  lenghtType: string = "custom";
  lenghtOption: string | undefined = undefined;
  disableInputs: boolean = false;
  disableLengthInput: boolean = false;
  curView: string = "weight";
  sheetsPerPackage: number = 10;
  currentWeight: number = 0;
  width: number = 0;
  thickness: number = 0;
  packProductRowMaxStockQuantity: number | undefined = undefined;
  productCodeNumberOfSheets: string = "";
  productCodeWeight: string = "";
  originalProductCode: string = "";

  maxLenght: number = 12000;
  minLenght: number = 350;
  triggerMinLenght: boolean = false;

  iconTypes = ICON_TYPE;

  siteUid: string = "";
  numberFormatter: Intl.NumberFormat = new Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 0
  });

  protected readonly isAsturias = isAsturias;

  constructor(
    private baseSiteService: BaseSiteService,
    private launchDialogService: LaunchDialogService
  ) {}

  ngOnInit() {
    this.baseSiteService.getActive().subscribe(baseSite => this.siteUid = baseSite);
    this.launchDialogService.data$.subscribe((dialogData: GonvarriCartUiEventAddToCart) => {
      if(dialogData.product) {
        this.product = dialogData.product;

        if (this.product.isContract && !this.product.isCustomLength) {
          this.lenghtType = String(this.product.standardLength);
          this.disableLengthInput = true;
          this.curLenght = this.product.standardLength;
        }
        else if (this.product.isContract && this.product.isCustomLength) {
          this.lenghtType = "custom";
          this.disableLengthInput = false;
        }
        else {
          this.lenghtOption = dialogData.lenght;
          this.lenghtType = this.lenghtOption ? this.lenghtOption : "custom";
          this.disableInputs = dialogData.disableInputs ? dialogData.disableInputs : false;
          this.curLenght = dialogData.lenght ? Number(dialogData.lenght.replaceAll(".", "").replaceAll(",", ".")) : 1000;
        }

        this.packageWeigth = dialogData.weight ? Number(dialogData.weight) : DEFAULT_KG;
        this.width = Number(dialogData.width?.replaceAll(".", "").replaceAll(",", "."));
        this.thickness = Number(dialogData.thickness?.replaceAll(".", "").replaceAll(",", "."));
        this.packProductRowMaxStockQuantity = dialogData.packProductRowMaxStockQuantity;
        this.originalProductCode = this.product.code as string;
        this.productCodeNumberOfSheets = this.originalProductCode.endsWith("_p") ? this.originalProductCode : this.originalProductCode + "_p";
        this.productCodeWeight = this.originalProductCode.endsWith("_p") ? this.originalProductCode.substring(0, this.originalProductCode.length - 2) : this.originalProductCode;
      }
    });
    this.updateCurrentKg();
  }

  updateProductCode(): void {
    if (this.product) {
      this.product.code = this.productCodeWeight;
      if(this.lenghtType.includes("custom")) {
        let certified
        if (this.product.code.includes("_")) {
          certified = this.product.code.match(/_.*/)
        }
        const productCodeParts: string[] = this.product.code?.split("X") as string[];

        const newProductCode = productCodeParts
          .splice(0, productCodeParts.length - 1)
          .reduce((productCode, curPart) => productCode + curPart + "X", "");
        if (certified) {
          this.product.code = newProductCode.substring(0, newProductCode.length - 1) + certified;
        } else {
          this.product.code = newProductCode.substring(0, newProductCode.length - 1);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.callCloseModal(undefined);
  }

  checkMinAndMaxLenght(): void {
    this.triggerMinLenght = false;
    if(this.curLenght > this.maxLenght) {
      this.curLenght = this.maxLenght;
    }else if(this.curLenght < this.minLenght) {
      this.curLenght = this.minLenght;
      this.triggerMinLenght = true;
    }
  }

  passThrought(value: any): any {
    return value;
  }

  formatNumber(value: any): string {
    if(value === undefined || value === null) {
      value = 0;
    }
    value = Number(value);
    return this.numberFormatter.format(value);
  }

  private resetState(): void {
    this.curLenght = 1000;
    this.lenghtType = "custom";
    this.lenghtOption = undefined;
    this.productCodeNumberOfSheets = "";
    this.productCodeWeight = "";
    this.triggerMinLenght = false;
  }

  callCloseModal(event: MouseEvent | undefined): void {
    if(this.product) {
      this.product.code = this.originalProductCode;
    }
    this.resetState();
    this.launchDialogService.closeDialog('dismiss');
  }

  changeViewToKG(): void {
    if(this.curView.includes("sheets")) {
      this.curView = "weight";
    }
    this.updateProductCode();
  }

  changeQuickStockView(): void {
    this.curView = this.curView.includes("weight") ? "sheets" : "weight";
    if(this.product) {
      this.product.code = this.originalProductCode;
      if(this.curView.includes("sheets")) {
        this.lenghtType = this.lenghtOption as string;
        this.product.code = this.productCodeNumberOfSheets;
      }else {
        this.product.code = this.productCodeWeight;
      }
    }
  }

  updateCurrentKg(): void {
    this.currentWeight = calcKgEach(this.thickness, this.width, this.curLenght, this.sheetsPerPackage);
  }

  protected readonly MIN_KG = MIN_KG;
  protected readonly MAX_KG = MAX_KG;
}
